import React from 'react';
import './Overview.scss';

function Overview (props) {

  const modalToggler = () => {
    props.modalToggler("contact", "")
  }

  //check whether to render webp or png
  let imageType = "png"
  if (props.webP === "webp") {
    imageType = "webp"
  }

  const GAEvent = (event) => {
    if (document.location.hostname.indexOf("flex.basler.com") > -1) {
      window.gtag('event', event)
    }
  }

  return (
    <div className={'Overview ' + props.windowSize}>
      <div className="section-one-background">
        <div style={{backgroundImage: "url(" + process.env.PUBLIC_URL + '"/Assets/Images/FLEX-Background-2.' + imageType + '")'}}>
          <img alt="campaign-text" src={process.env.PUBLIC_URL + '/Assets/Images/' + (props.windowSize === "Web" ? 'Header-text.' + imageType : 'Header-text-mobile.' + imageType)} />
        </div>
      </div>
      <div className="overview-image column-left">
        <img alt="Flex Case" src={process.env.PUBLIC_URL + '/Assets/Images/Flex-image.' + imageType} />
      </div>
      <div className="overview-section column-right">
        <div className="text-container">
          <h2>INTRODUCING THE <span>BE1-FLEX,</span><br></br>A NEW RELAY PLATFORM, INSIDE AND OUT.</h2>
          <p>
            The BE1-FLEX is a completely new and groundbreaking platform, designed to be the most versatile and easy to use protective relay in the industry. The BE1-FLEX can be extensively customized upon order and can be easily reconfigured in the field with interchangeable circuit boards and easily modified software parameters. The large touchscreen control panel, with pinch and zoom capability, allows for monitoring and control of any aspect of the system.
          </p>
          <p>
            <button onClick={() => modalToggler()}>Request a Webinar</button>
            <a onClick={() => GAEvent('BE1-Flex product page')} href="https://www.basler.com/Product/BE1-FLEX">Product Page</a>
          </p>
        </div> 
      </div>
      <div className="compatibility-section column-left">
        <div className="text-container">
          <h2>The Future Demands <span>- Forward Compatibility</span></h2>
          <p>
            Today's products adapting to yet to be identified future needs is the basis for our BE1-FLEX. In a changing world, companies often think about backward compatibility and how next generation products will work in older applications. At Basler, we think about how our current products will work in your next generation applications. With a field-configurable design and user-customizable controls, your BE1-FLEX will continue to meet your demanding applications for years to come.
          </p>
        </div>
      </div>
      <div className="compatibility-image column-right">
        <img alt="Flex Case" src={process.env.PUBLIC_URL + '/Assets/Images/BE1-FLEX-Front.' + imageType} />
        <img alt="Flex Case" src={process.env.PUBLIC_URL + '/Assets/Images/BE1-FLEX-Rear.' + imageType} />
      </div>
      <div className="section-three-background"></div>
      <div className="insight-section column-right">
        <div className="text-container">
          <h2>The Future Demands <span>- Relentless Insight</span></h2>
          <p>
            The BE1-FLEX integrates customizable graphical settings and logic with a powerful HMI, allowing you to monitor what's important in real time in your desired terminology. From simple alarms to complex mathematical indicators, Basler empowers you to easily look after exactly what you need without making you navigate through overly complicated screens or function interpretation.
          </p>
        </div>
      </div>
      <div className="insight-image column-left">
        <img alt="Flex Case" src={process.env.PUBLIC_URL + '/Assets/Images/HMI-Sample2.' + imageType} />
      </div>
      <div className="transformation-section column-left">
        <div className="text-container">
          <h2>The Future Demands <span>- Transformation</span></h2>
          <p>The BE1-FLEX challenges the status quo from product selection and specification to commissioning. A simple configuration process ensures you get the features you need without searching through hundreds of part numbers and spending hours reading specification sheets. The simplicity and flexibility of Basler's BESTCOMSPlus software with available application templates will streamline the setup and programming of your device.</p>
        </div>
      </div>
      <div className="transformation-image column-right">
        <img alt="Flex Case" src={process.env.PUBLIC_URL + '/Assets/Images/laptop-with-BestComs.' + imageType} />
      </div>
      
    </div>
  );
}

export default Overview;